export default {
	save: 'Salvesta järjehoidja',
	load: 'Lae järjehoidja',
	saved: 'Järjehoidja lisatud!',
	loaded: 'Järjehoidja laetud!',
	deleted: 'Järjehoidja kustutatud!',
	notFound: 'Järjehoidjat ei leitud!',
	empty: 'Ühtegi järjehoidjat pole salvestatud.',
}
